export const restaurants = [
  {
    id: 1,
    name: "The Monk's Cellar",
    category: "Brewery & Restaurant",
    cuisine: "American Craft",
    description: "Award-winning craft brewery with house-made beers and elevated pub fare in a historic downtown setting.",
    image: "https://public.readdy.ai/ai/img_res/2a9b9f012e839280af5ee6d992254714.jpg",
    rating: 4.7,
    priceRange: "$$",
    address: "340 Lincoln St",
    hours: "11am - 10pm"
  },
  {
    id: 2,
    name: "Goose Port",
    category: "Fine Dining",
    cuisine: "California Contemporary",
    description: "Upscale dining featuring locally-sourced ingredients, craft cocktails, and an extensive wine list.",
    image: "https://readdy.ai/api/search-image?query=Elegant%20fine%20dining%20restaurant%20interior%20modern%20California%20style%20white%20tablecloths%20ambient%20lighting%20wine%20glasses%20sophisticated%20decor%20open%20kitchen%20concept%20warm%20wood%20accents&width=600&height=400&seq=food2&orientation=landscape",
    rating: 4.8,
    priceRange: "$$$",
    address: "400 Vernon St",
    hours: "5pm - 10pm"
  },
  {
    id: 3,
    name: "Sienna Restaurant",
    category: "Fine Dining",
    cuisine: "New American",
    description: "Chef-driven seasonal menu with farm-to-fork philosophy in an intimate, elegant atmosphere.",
    image: "https://readdy.ai/api/search-image?query=Intimate%20upscale%20restaurant%20with%20warm%20sienna%20tones%20elegant%20table%20settings%20soft%20candlelight%20modern%20artwork%20on%20walls%20white%20plates%20fine%20dining%20ambiance%20romantic%20setting&width=600&height=400&seq=food3&orientation=landscape",
    rating: 4.9,
    priceRange: "$$$",
    address: "Historic Old Town",
    hours: "5pm - 9pm"
  },
  {
    id: 4,
    name: "Lazy Dog Restaurant & Bar",
    category: "Casual Dining",
    cuisine: "American Comfort",
    description: "Family-friendly spot with handcrafted American comfort food, seasonal dishes, and dog-friendly patio.",
    image: "https://readdy.ai/api/search-image?query=Warm%20casual%20American%20restaurant%20interior%20comfortable%20booths%20rustic%20lodge%20style%20decor%20fireplace%20wooden%20beams%20family%20friendly%20atmosphere%20cozy%20lighting%20mountain%20cabin%20feel&width=600&height=400&seq=food4&orientation=landscape",
    rating: 4.5,
    priceRange: "$$",
    address: "1185 Galleria Blvd",
    hours: "11am - 11pm"
  },
  {
    id: 5,
    name: "Mikuni Japanese Restaurant",
    category: "Japanese",
    cuisine: "Sushi & Japanese",
    description: "Sacramento's favorite sushi destination with creative rolls, fresh sashimi, and vibrant atmosphere.",
    image: "https://readdy.ai/api/search-image?query=Modern%20Japanese%20sushi%20restaurant%20interior%20sleek%20design%20sushi%20bar%20counter%20fresh%20fish%20display%20minimalist%20Asian%20decor%20warm%20wood%20tones%20contemporary%20lighting%20clean%20aesthetic&width=600&height=400&seq=food5&orientation=landscape",
    rating: 4.6,
    priceRange: "$$",
    address: "1565 Eureka Rd",
    hours: "11:30am - 9:30pm"
  },
  {
    id: 6,
    name: "Brookfields Restaurant",
    category: "American Classic",
    cuisine: "Breakfast & Brunch",
    description: "Beloved local institution serving hearty American breakfasts and comfort food since 1977.",
    image: "https://readdy.ai/api/search-image?query=Classic%20American%20diner%20restaurant%20interior%20retro%20charm%20breakfast%20counter%20cozy%20booths%20vintage%20decor%20warm%20morning%20light%20homestyle%20comfort%20nostalgic%20atmosphere&width=600&height=400&seq=food6&orientation=landscape",
    rating: 4.4,
    priceRange: "$",
    address: "5040 Rocklin Rd",
    hours: "6am - 2pm"
  },
  {
    id: 7,
    name: "Yard House",
    category: "Sports Bar & Grill",
    cuisine: "American",
    description: "Over 100 craft and imported beers on tap with an extensive menu of American favorites.",
    image: "https://readdy.ai/api/search-image?query=Modern%20sports%20bar%20interior%20with%20extensive%20beer%20tap%20wall%20large%20screens%20contemporary%20industrial%20design%20high%20ceilings%20energetic%20atmosphere%20bar%20seating%20warm%20lighting&width=600&height=400&seq=food7&orientation=landscape",
    rating: 4.3,
    priceRange: "$$",
    address: "1185 Galleria Blvd",
    hours: "11am - 12am"
  },
  {
    id: 8,
    name: "Nixtaco Mexican Kitchen",
    category: "Mexican",
    cuisine: "Modern Mexican",
    description: "Authentic Mexican street food with house-made tortillas, fresh salsas, and creative tacos.",
    image: "https://readdy.ai/api/search-image?query=Vibrant%20modern%20Mexican%20restaurant%20colorful%20decor%20authentic%20tacos%20on%20plates%20fresh%20ingredients%20display%20warm%20festive%20atmosphere%20terracotta%20accents%20open%20kitchen%20lively%20setting&width=600&height=400&seq=food8&orientation=landscape",
    rating: 4.6,
    priceRange: "$",
    address: "460 Roseville Square",
    hours: "11am - 9pm"
  },
  {
    id: 9,
    name: "Paul Martin's American Grill",
    category: "Fine Dining",
    cuisine: "American Contemporary",
    description: "Farm-to-table dining with seasonal menus, craft cocktails, and an impressive wine selection.",
    image: "https://readdy.ai/api/search-image?query=Sophisticated%20American%20grill%20restaurant%20interior%20with%20dark%20wood%20accents%20leather%20booths%20warm%20lighting%20open%20kitchen%20farm%20to%20table%20concept%20elegant%20contemporary%20design&width=600&height=400&seq=food9&orientation=landscape",
    rating: 4.7,
    priceRange: "$$$",
    address: "1455 Eureka Rd",
    hours: "11:30am - 9:30pm"
  },
  {
    id: 10,
    name: "Zocalo Roseville",
    category: "Mexican",
    cuisine: "Upscale Mexican",
    description: "Elevated Mexican cuisine with handcrafted margaritas, fresh guacamole, and vibrant atmosphere.",
    image: "https://readdy.ai/api/search-image?query=Upscale%20Mexican%20restaurant%20interior%20colorful%20tile%20work%20modern%20decor%20tequila%20bar%20display%20fresh%20guacamole%20preparation%20vibrant%20festive%20atmosphere%20elegant%20Mexican%20design&width=600&height=400&seq=food10&orientation=landscape",
    rating: 4.5,
    priceRange: "$$",
    address: "1174 Roseville Pkwy",
    hours: "11am - 10pm"
  },
  {
    id: 11,
    name: "Buca di Beppo",
    category: "Italian",
    cuisine: "Italian Family Style",
    description: "Authentic Italian family-style dining with generous portions, classic recipes, and festive atmosphere.",
    image: "https://readdy.ai/api/search-image?query=Traditional%20Italian%20restaurant%20interior%20family%20style%20dining%20red%20checkered%20tablecloths%20vintage%20Italian%20decor%20warm%20cozy%20atmosphere%20pasta%20dishes%20wine%20bottles%20rustic%20charm&width=600&height=400&seq=food11&orientation=landscape",
    rating: 4.4,
    priceRange: "$$",
    address: "1249 Galleria Blvd",
    hours: "11am - 10pm"
  },
  {
    id: 12,
    name: "Squeeze Burger",
    category: "Casual Dining",
    cuisine: "Burgers & Shakes",
    description: "Gourmet burgers made with fresh ingredients, hand-cut fries, and old-fashioned milkshakes.",
    image: "https://readdy.ai/api/search-image?query=Modern%20burger%20restaurant%20interior%20with%20gourmet%20burgers%20on%20display%20fresh%20ingredients%20bar%20casual%20contemporary%20design%20bright%20lighting%20milkshake%20station%20retro%20modern%20fusion&width=600&height=400&seq=food12&orientation=landscape",
    rating: 4.6,
    priceRange: "$",
    address: "1017 Galleria Blvd",
    hours: "11am - 9pm"
  }
];

export const categories = [
  { id: 'all', name: 'All', icon: 'ri-restaurant-line' },
  { id: 'fine-dining', name: 'Fine Dining', icon: 'ri-goblet-line' },
  { id: 'casual', name: 'Casual Dining', icon: 'ri-restaurant-2-line' },
  { id: 'breweries', name: 'Breweries', icon: 'ri-beer-line' },
  { id: 'cafes', name: 'Cafes & Coffee', icon: 'ri-cup-line' }
];